// extracted by css-extract-rspack-plugin
export default {"breadcrumb":"n7I0X","trail":"ZVFFW","content":"c6DUo","icon":"iIQl1","text":"UoGAO","clickable":"XSImJ"};